import React from "react";
import { $t } from './i18n';
import ReactWOW from "react-wow";

export const Submission = ({ message }) => {
  return message ? (
    <section id="submission" className="white">
      <div className="content">
        <h2 className="section-title">{$t(message.title)}</h2>
        <div className="proposal paragraph">
          {
            message.content.desc.map(item => <p className="desc" key={item}>{$t(item)}</p>)
          }
          {
            (message.content.list || []).map(item => <p className="item" key={item}>{$t(item)}</p>)
          }
        </div>
        <div className="formate paragraph">
          <p className="desc">{$t(message.formate.desc)}</p>
          {
            (message.formate.list || []).map(item => <p className="item" key={item}>{$t(item)}</p>)
          }
        </div>
        <div className="shortlisted paragraph">
          <p className="desc">{$t(message.shortlisted.desc)}</p>
          {
            (message.shortlisted.list || []).map(item => <p className="item" key={item}>{$t(item)}</p>)
          }
        </div>
        <p className="explain">{$t(message.explain)}</p>
      </div>
    </section>
  ) : null
};
export const SubmissionSimple = ({ message, canAnimation = true }) => {
  const { list = [], explain } = message;
  return message ? (
    <>
      <div className="content">
        {
          list.map((list, index) => (
            <ReactWOW animation={canAnimation ? 'fadeInUp' : ''} delay={`${index * 0.1}s`} key={list.title || index}>
              <div className="simple-info paragraph">
                <p className="desc" >{$t(list.title)}</p>
                <p className="item" >{$t(list.desc)}</p>
              </div>
            </ReactWOW>
          ))
        }
        <p className="explain">{$t(explain)}</p>
      </div>
    </>
  ) : null
};
